<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dghLXo/tc-custom/9781398499133.jpg?1680370567290" alt="This image is the cover for the book The Menagerie"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Menagerie
      </h1>
      <p class="bookDescription body article font2">
        <p>This book is a collection of eight separate stand-alone short stories. These stories will take you on a journey of suspense, adventure, mystery and horror. There is something for everyone, whether you like gritty detective stories, mythological adventures or enticing horror, all that and more in this Menagerie.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joshua Whittaker
      </h2>
      
      <p class="authorDescription body article">Joshua Whittaker was born in the West Midlands, England. From a young age, he was a fan of sci-fi, fantasy books and movies. Later, he also developed an interest in horror. The author identifies himself as bisexual.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dc60f148